<template>
  <section class="bg-[#efe9dd] px-4 py-10 sm:px-5 md:py-28">
    <div class="mx-auto max-w-7xl">
      <div class="mb-7 grid gap-4 md:mb-12 md:grid-cols-[0.8fr_1.2fr] md:items-end md:gap-8">
        <div>
          <p class="section-kicker">Selected Projects</p>
          <h2 class="section-title">
            Residential, commercial, hospitality, industrial, and high-rise work.
          </h2>
          <div class="section-rule"></div>
        </div>
        <p class="section-copy mt-0">
          A concise visual archive of built work, design proposals, interior
          studies, and spatial explorations across varied project types.
        </p>
      </div>

      <div v-if="isLoading && !allProjects.length" class="grid gap-3 md:grid-cols-2 md:gap-5 xl:grid-cols-3">
        <div class="h-64 soft-loader sm:h-80" v-for="index in 6" :key="`project-placeholder-${index}`"></div>
      </div>
      <div v-else class="columns-1 gap-3 md:columns-2 md:gap-5 xl:columns-3">
        <figure
          class="image-surface mb-3 break-inside-avoid transition duration-500 hover:-translate-y-1 hover:shadow-[0_24px_70px_rgba(37,45,41,0.18)] md:mb-5"
          v-for="(item, index) in allProjects"
          :key="`${item}-${index}`"
        >
          <img
            class="w-full bg-[#eee9df]"
            :src="item"
            alt=""
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import { useStorageFolder } from "@/composables/useStorageAssets";
import { storageFolders } from "@/config/storageSections";

export default {
  setup() {
    const { assets: projectsl, loading: landscapeLoading } = useStorageFolder(storageFolders.projectsLandscape);
    const { assets: projectsp, loading: portraitLoading } = useStorageFolder(storageFolders.projectsPortrait);
    const allProjects = computed(() => [...projectsl.value, ...projectsp.value]);
    const isLoading = computed(() => landscapeLoading.value || portraitLoading.value);

    return { allProjects, isLoading, projectsl, projectsp, landscapeLoading, portraitLoading };
  },
};
</script>

<style lang="scss" scoped></style>
